import {DictionaryItem} from './dictionary.model';
import {Address} from './address.model';
import {GenericEntity} from './generic-entity.model';

export class Party extends GenericEntity {
    partyType: DictionaryItem;
    email: string;
    phoneNumber: string;
    address: Address;
    companyName: string;
    nip: string;
    regon: string;
    pesel: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    gender: DictionaryItem;
    citizenship: DictionaryItem;
    documentType: DictionaryItem;
    documentNumber: string;
}
